import { ShopOutlined } from '@ant-design/icons';
import { Tag, Button, Form, message, Modal, Tabs, Alert, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { authFetch } from '../../../../common/request/authFetch';
import FormItemPublishPhotoType from '../../../components/model/business/forms/FormItemPublishPhotoType';
import FormItemUploadPhoto from '../../../components/model/business/forms/FormItemUploadPhoto';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { MediaCarrousel } from '../../menuInfo/common/MediaCarrousel';
import { DrawerPanelTitle, modalPanelStyles } from '../../common/Drawers/DrawerPanelTitle';

const ImagePublishPanel = ({
	selectedRowKeys,
	location,
	onCancel,
	onFinish,
}: any) => {

	const { projectGroup } = useAuth();
	const [form4] = Form.useForm();
	const { t } = useTranslation();		
	const photoValue = Form.useWatch('photo', form4);

	const isButtonDisabled = !photoValue || photoValue.length === 0;
	const submitMedia = async (values: any) => {
	
		const photos = values.photo;
	
		if (photos && photos.length > 0) {

			const urls = photos.map((file: any) => file.url || file.response?.url);

			const pendingURLs = urls.some((url: string) => !url);

			if (pendingURLs) {
				message.warning('Esperando a que todas las imágenes terminen de subir...');
				return;
			}
	
			const data = {
				category: 'ADDITIONAL',
				photosURL: urls,
				locationsNames: selectedRowKeys
			};
			
			massivePublish(data, 'localPostMedia');                 
		} else {
			message.error('Por favor, selecciona una imagen');
		}
	};

	const massivePublish = async (data : any, type: string) => {
		await authFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/' + projectGroup.group + '/locations/' + type, { method: 'POST', data: data })
		.then((res) => {
			if (res) {	
				message.loading(t('view.forms.modal.bulk.triggered'), 5);											
			} else {
				message.error(t('view.forms.modal.bulk.error'), 5);							
			}
		});
		onFinish();	
	}

  return (
		<Modal
			open={true}
			onCancel={onCancel}
			footer={null}
			width={'60%'}
			{...modalPanelStyles}
			title={
				location ? (
					<DrawerPanelTitle
						title="Fotos y videos"
						location={location}
					/>
				) : (
					<DrawerPanelTitle
						title="Fotos y videos Masivo"
						locationsCount={selectedRowKeys.length}
						massive
					/>
				)
			}
		>
			<Alert type='info' showIcon={true} message='La subida de fotos y de videos no siempre es inmediata, puede tardar minutos o incluso horas'/>
			<div style={{ paddingBottom: '30px', margin:'10px 50px' }}>
				<Form layout='vertical' form={form4} onFinish={submitMedia}>
				<Row gutter={16} align="middle">
					<Col flex="auto">
						<FormItemUploadPhoto 
							maxPhotos={5} 
							includeVideo={true}
						/>
					</Col>
					<Col>						
						<Form.Item> 
						<Button 
							type="primary" 
							shape="round"
							size="large"
							disabled={isButtonDisabled}
							onClick={() => form4.submit()}
							style={{ minWidth: '160px' }} // Un ancho mínimo para que el botón no baile al cambiar el texto
						>
							{t('dictionary.publish')} 
							{!isButtonDisabled && ` en ${selectedRowKeys.length} locales`}
						</Button>
						</Form.Item>
					</Col>
				</Row>
				</Form>
			</div>
			{location && <MediaCarrousel locationId={location.composeId}/>}
		</Modal>
	)
}

export default ImagePublishPanel;